<template lang="pug">
div.alert.text-center
    h4 {{$t('autoInscription.shareTheLink')}}
    br
    .form-group
      .input-group(style='width: 90%; margin-left: auto; margin-right: auto')
        input.text-center.form-control(id='autoLink', type='text', :value='autoInscriptionLink' readonly v-clipboard:copy="autoInscriptionLink", v-clipboard:success="onCopy", style="color: #007700")
        span.input-group-btn
          button.btn.btn-default(type="button" v-clipboard:copy="autoInscriptionLink", v-clipboard:success="onCopy")
            i.fa.fa-clipboard
    .row
      .col-sm-6
        qrcode(:value="autoInscriptionLink", :options="{ width: 200 }")
      .col-sm-6
        br
        br
        h5 {{$t('autoInscription.shareDirect')}}
        social-sharing(:url='autoInscriptionLink', :title='"Deviens membre de " + this.groop.name + " sur GroopUs.com !"', description='', hashtags='groopus.com,simple,efficace',inline-template='')
          .btn-group.text-center
            network.btn.btn-default(title='Via email', network='email', style="float: initial; margin-bottom: 10px")
              i.fa.fa-envelope
              |  Email
            network.btn.btn-default(title='Via SMS', network='sms', style="float: initial; margin-bottom: 10px")
              i.fa.fa-commenting-o
              |  SMS
            network.btn.btn-default(title='Via facebook', network='facebook', style="float: initial; margin-bottom: 10px")
              i.fa.fa-facebook
              |  Facebook
            network.btn.btn-default(title='Via Telegram', network='telegram', style="float: initial; margin-bottom: 10px")
              i.fa.fa-telegram
              |  Telegram
            network.btn.btn-default(title='Via Whatsapp', network='whatsapp', style="float: initial; margin-bottom: 10px")
              i.fa.fa-whatsapp
              |  Whatsapp
            network.btn.btn-default(title='Via LinkedIn', network='linkedin', style="float: initial; margin-bottom: 10px")
              i.fa.fa-linkedin
              |  LinkedIn
            network.btn.btn-default(title='Via Reddit', network='reddit', style="float: initial; margin-bottom: 10px")
              i.fa.fa-reddit
              |  Reddit
            network.btn.btn-default(title='Via Skype', network='skype', style="float: initial; margin-bottom: 10px")
              i.fa.fa-skype
              |  Skype
    br
    br
    small {{$t("autoInscription.linkToShare.shareIt")}}
      a(:href='autoInscriptionLink', target="_blank") 
        |  {{$t("autoInscription.linkToShare.testIt")}}
        i.fa.fa-external-link
</template>
<script>
import Vue from 'vue'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

var SocialSharing = require('vue-social-sharing')
Vue.use(SocialSharing)

import { success } from '@/components/shared/Notify'

import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  props: {
    groop: {
      required: true,
      type: Object
    }
  },
  components: {
    qrcode: VueQrcode
  },
  computed: {
    autoInscriptionLink() {
      if (!this.groop) {
        return 'loading...'
      }
      if (this.groop.autoInscription.method === 'private') {
        return (
          process.env.baseUrl + '/#/join/' +
          this.groop.id +
          '/' +
          this.groop.privateAutoInscriptionKey
        )
      } else {
        return (
          process.env.baseUrl + '/#/' + this.groop.url
        )
      }
    }
  },
  methods: {
    onCopy () {
      success(this.$i18n.t('autoInscription.copiedLink'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// AutoInscription.vue?11453fce